// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import LinkIconOrigin from '@mui/icons-material/Link'
import CopyIconOrigin from '@mui/icons-material/ContentCopy'
import NewTabIconOrigin from '@mui/icons-material/OpenInNew'
import VisibilityIconOrigin from '@mui/icons-material/Visibility'
// utils
import { size } from 'polished'

const NewTabIcon = styled(NewTabIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

const VisibilityIcon = styled(VisibilityIconOrigin)`
  ${size('18px')};

  path {
    fill: ${colors.blue500};
  }
`

const LinkIcon = styled(LinkIconOrigin)<{ active?: boolean }>`
  ${size('18px')};

  path {
    fill: ${({ active }) => (active ? colors.blue500 : colors.gray300)};
  }
`

const CopyIcon = styled(CopyIconOrigin)<{ active?: boolean }>`
  ${size('14px')};

  path {
    fill: ${({ active }) => (active ? colors.blue500 : colors.gray300)};
  }
`

export { NewTabIcon, VisibilityIcon, LinkIcon, CopyIcon }
